<template>
	<div
		v-show="!isExpired && description"
		class="absolute top-0 left-0 px-4 py-1 text-base flex items-center justify-center"
		:style="{
			color: specialPrice?.text,
			backgroundColor: specialPrice?.background
		}"
	>
		<div v-if="description" v-html="description" />
	</div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import type { SpecialPrice } from "~/types/storyblok/storyblok";
import { sanitizeHtml } from "~/layers/base/utils/html";
import { parseNorceDate } from "~/utils/parseNorceDate";

interface Props {
	priceListId: number;
	specialPrice?: SpecialPrice;
}
const { priceListId } = defineProps<Props>();
const { allPriceLists } = storeToRefs(useProductStore());

// The product's own list, which need not be one the shopper is priced from.
const currentPriceList = computed(() =>
	allPriceLists.value.find((priceList) => priceList.Id === priceListId)
);
const description = computed(() =>
	sanitizeHtml(currentPriceList.value?.Description)
);

const isExpired = computed(
	() => parseNorceDate(currentPriceList.value?.EndDate) <= Date.now()
);
</script>
